import { Debt, User } from '../../core/data';

type Profile = Debt | User;

export const isAdmin = (profile?: Profile): boolean => {
  if (profile && profile.hasOwnProperty('roles')) {
    const user = profile as User;
    return user.roles && user.roles.length > 0;
  }
  return false;
};

export const isDebt = (profile?: Profile): boolean => {
  return profile && profile.hasOwnProperty('amount');
};



// WEBPACK FOOTER //
// ./src/app/shared/utils/profile.utils.ts